import React, { FC, ReactElement } from 'react'

export const DatabaseSidebar: FC = (): ReactElement => (
    <svg fill='currentColor' viewBox='0 0 100 100'>
        <path d='m98.957 48.957v-10c0-1.043-1.25-1.668-2.082-1.043-10.207 8.125-28.543 12.293-46.875 12.293-18.125 0-36.457-4.168-46.875-12.293-0.83203-0.625-2.082 0-2.082 1.043v10 0.83203c0 11.668 21.875 21.254 48.957 21.254s48.957-9.582 48.957-21.457v-0.62891z' />
        <path d='m98.957 76.875v-10c0-1.043-1.25-1.668-2.082-1.043-10.207 8.125-28.543 12.293-46.875 12.293-18.125 0-36.457-4.168-46.875-12.293-0.83203-0.625-2.082 0-2.082 1.043v10 0.83203c0 11.668 21.875 21.25 48.957 21.25s48.957-9.582 48.957-21.457v-0.625z' />
        <path d='m98.957 22.5c0 11.852-21.918 21.457-48.957 21.457s-48.957-9.6055-48.957-21.457 21.918-21.457 48.957-21.457 48.957 9.6055 48.957 21.457' />
    </svg>
)
